<div class="search-grid" [ngClass]="{'is-focus' : inputIsFocus}">
  <input [ngModel]="searchText" type="text" placeholder="Rechercher ..."
    (ngModelChange)="updSearch($event)"
    (keydown.enter)="search()" (focus)="inputIsFocus = true"
    (blur)="inputIsFocus = false"/>
  @if (isSearch) {
    <div class="search-close" (click)="clearSearchInput()">
      <i class="icon icon-x"></i>
    </div>
  }
  <button class="button-main-icon" (click)='search()'>
    <i class="icon icon-search1"></i>
  </button>
</div>
